import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AzureMonitoringService } from 'app/core/services/AzureMonitoringService';
import { CustomersRestService } from 'app/core/services/rest/customers.rest.service';
import { RestService } from 'app/core/services/rest/rest.service';
import { UserContextRestService } from 'app/core/services/rest/user-context.rest.service';
import { AbstractEffects } from 'app/core/store/AbstractEffects';
import { RootState } from 'app/core/store/index';
import * as actions from 'app/core/store/session/user-context/user-context.actions';
import { CustomersLoadAction } from 'app/core/store/session/user-context/user-context.actions';
import { from, Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { NotificationService } from 'app/core/services/notification.service';
import { AuthenticationService } from '../../../authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class UserContextEffects extends AbstractEffects {
  private authenticationService = inject(AuthenticationService);
  loadCustomers$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<CustomersLoadAction>(actions.CUSTOMERS_LOAD),
      withLatestFrom(this.authenticationService.authenticated$, (action, isAuthenticated) => ({
        action,
        isAuthenticated,
      })),
      filter(({ isAuthenticated }: { isAuthenticated: boolean }) => isAuthenticated),
      switchMap(({ action }: { action: CustomersLoadAction; isAuthenticated: boolean }) => {
        return from(this.customersRestService.getSoldTosForSalesOrganisation(action.payload)) // Request customers
          .pipe(
            map(userContext => {
              return new actions.CustomersLoadSuccessAction(userContext);
            }),
            catchError(err => {
              return this.handleFail(err, 'Get customers', [of(new actions.CustomersLoadFailAction(err))]);
            })
          );
      })
    )
  );

  constructor(
    private store: Store<RootState>,
    azureMonitoringService: AzureMonitoringService,
    private actions$: Actions,
    private userContextRestService: UserContextRestService,
    private customersRestService: CustomersRestService,
    translateService: TranslateService,
    private restService: RestService,
    notificationService: NotificationService,
  ) {
    super(translateService, azureMonitoringService, notificationService);
  }
}
